import { render } from "./PatientComments.vue?vue&type=template&id=773e84e6&scoped=true"
import script from "./PatientComments.vue?vue&type=script&lang=js"
export * from "./PatientComments.vue?vue&type=script&lang=js"

import "./PatientComments.vue?vue&type=style&index=0&id=773e84e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773e84e6"]])

export default __exports__